module.exports = __webpack_public_path__ + "static/media/ionicons.3f2acd40.eot";